import {Route, Routes, Outlet} from 'react-router-dom'
import {PageTitle} from '../../../../_metronic/layout/core'
import {ApplicationsListWrapper} from './applications-list/ApplicationsList'

const ApplicationsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/*'
          element={
            <>
              <PageTitle>Job Applications</PageTitle>
              <ApplicationsListWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default ApplicationsPage
